// MainLayout.jsx
import React from "react";
import TopNavbar from "./top-nav-bar";
import Sidebar from "./sidebar";
import AppFooter from "./footer";
import ChatBot from '../chatbot/ChatBot';

const MainLayout = ({ children }) => {
  return (
    <div>
      <TopNavbar />
      <Sidebar />
      <div className="content">{children}</div>
      {/* <ChatBot /> */}
      <AppFooter />
    </div>
  );
};

export default MainLayout;
